import { render, staticRenderFns } from "./GroupsFilterByUser.vue?vue&type=template&id=34808f51"
import script from "./GroupsFilterByUser.vue?vue&type=script&lang=js"
export * from "./GroupsFilterByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports